import { render, staticRenderFns } from "./couponSetting.vue?vue&type=template&id=7ebcb435&scoped=true&"
import script from "./couponSetting.vue?vue&type=script&lang=js&"
export * from "./couponSetting.vue?vue&type=script&lang=js&"
import style0 from "./couponSetting.vue?vue&type=style&index=0&id=7ebcb435&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebcb435",
  null
  
)

export default component.exports